import React, {useEffect, useMemo, useState} from 'react'
import TelegramClientsList from "./telegramClientsList";
import ClientModalBox from "../elements/clientmodalbox";
import {Carcontext} from "../context/carcontext";
import Alert from "../elements/alert";
import {useSelector} from "react-redux";

const TelegramClientsPage = () => {

    const [modal, setModal] = useState('')
    const [clientContext, setClientContext] = useState(null)
    const alertBox = useSelector(state => state.app.alertBox)
    const theme = useSelector(state => state.app.theme)

    useEffect(() => {
        const modal = document.querySelector('.modal-wrapper')
        setModal(modal)
    }, [])

    const OpenUserModal = (client) => {
        modal.style.cssText = "opacity: 1; visibility: visible;"
        setClientContext(client)
    }

    const userModal = useMemo(() => {
        return <ClientModalBox clients={clientContext}/>
    }, [clientContext])

    return (
        <Carcontext.Provider value={{
            OpenUserModal, theme
        }}>
            <div className="content">
                {alertBox && <Alert text={alertBox.text} type={alertBox.type}/>}
                <div className="wrapper">
                    <div className="modal-wrapper">
                        {userModal}
                    </div>
                    <TelegramClientsList />
                </div>
            </div>
        </Carcontext.Provider>
    )
}

export default TelegramClientsPage